module.exports = __webpack_public_path__ + "img/email-header-relationshipwithcolleagues@2x.8d64e763.png";